export default [
    {
        field: 'name',
        editable: false,
        sortable: true,
        valueSetter: (params) => {
            params.data.set('name', params.newValue)
        },
        valueGetter: (params) => {
            return params.data.attributes.name
        },
    },
    {
        field: 'id',
        editable: false,
        sortable: true,
        valueSetter: () => null,
        valueGetter: (params) => (params && params.data ? params.data.attributes.id : null),
    },
    {
        field: 'entity',
        editable: false,
        sortable: true,
        valueSetter: (params) => {
            params.data.set('entity', params.newValue)
        },
        valueGetter: (params) => {
            return params.data.attributes.entity
        },
    },
    {
        field: 'entity_id',
        editable: false,
        sortable: true,
        valueSetter: (params) => {
            params.data.set('entity_id', params.newValue)
        },
        valueGetter: (params) => {
            return params.data.attributes.entity_id
        },
    },
    {
        field: 'status',
        editable: false,
        sortable: true,
        valueSetter: (params) => {
            params.data.set('status', params.newValue)
        },
        valueGetter: (params) => {
            return params.data.attributes.status
        },
    },
    {
        field: 'time_updated',
        editable: false,
        sortable: true,
        valueSetter: (params) => {
            params.data.set('time_updated', params.newValue)
        },
        valueGetter: (params) => {
            return params.data.attributes.time_updated
        },
    },
]
